import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css'
import request from "../utils/request";
import Print from  "vue-print-nb"
Vue.use(Print)
import VueRouter from "vue-router";
Vue.use(VueRouter)
Vue.config.productionTip = false

Vue.use(ElementUI,{size:"small"});

// 引入iView-ui
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI)
Vue.prototype.request=request

import store from "@/store";

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// new Vue({
//   router,
//   beforeCreate() {
//     Vue.prototype.$bus = this  //安装全局事件总线
//     Vue.prototype.$store = store
//   },
//   render: h => h(App)
// }).$mount('#app')

new Vue({
  el:'#app',
  render: h => h(App),
  router,
  store,
  beforeCreate() {  //安装全局API
    Vue.prototype.$bus = this  //安装全局事件总线
  }
})
